import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {
  Area1Set,
  Area2Set,
  FullviewerSet,
  Map1Set,
  Map2Set,
  ModeSet,
  RendouSet,
  Rotate1Set,
  Rotate2Set,
  Static2Map1Set,
  Static2Map2Set,
  SyukurenSet,
  Year1Set,
  Year2Set,
  Zoomhanrei1Set,
  Zoomhanrei2Set,
} from "./App";
import {
  agedpop_now,
  agedpop_old,
  daypop_now,
  daypop_old,
  population_now,
  population_old,
  sales_now,
  sales_old,
  worker23_now,
  worker23_old,
} from "./kashikasetting";

export const MultiSetting = (props) => {
  const { modeset, setModeSet } = useContext(ModeSet);
  const { fullviewerset, setFullviewerSet } = useContext(FullviewerSet);
  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { syukurenset, setSyukurenSet } = useContext(SyukurenSet);
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { map2set, setMap2Set } = useContext(Map2Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const { rotate1set, setRotate1Set } = useContext(Rotate1Set);
  const { rotate2set, setRotate2Set } = useContext(Rotate2Set);
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);

  const multisetting = () => {
    // console.log(area1set);
    // console.log(props.area1set);
    // console.log(area2set);
    // console.log(props.area2set);
    {
      props.modeset && setModeSet(props.modeset);
    }
    {
      props.fullviewerset && setFullviewerSet(props.fullviewerset);
    }
    {
      props.rendouset && setRendouSet(props.rendouset);
    }
    {
      props.syukurenset && setSyukurenSet(props.syukurenset);
    }
    {
      props.map1set && setMap1Set(props.map1set);
    }
    {
      props.map2set && setMap2Set(props.map2set);
    }
    {
      props.static2map1set && setStatic2Map1Set(props.static2map1set);
    }
    {
      props.static2map2set && setStatic2Map2Set(props.static2map2set);
    }
    setRotate1Set(props.rotate1set || false);
    setRotate2Set(props.rotate2set || false);
    setArea1Set(props.area1set || area1set);
    setArea2Set(props.area2set || area2set);
    setYear1Set(props.year1set || static2map1set.year5 || 2015);
    setYear2Set(props.year2set || static2map1set.year5 || 2015);
  };

  var linkto = props.to || "/map";
  var locationparam = "";
  // console.log(props.modeset);
  if (props.modeset == "3" || props.modeset == "7") {
    locationparam = "";
    locationparam = "?_" + (props.area2set || area2set || area1set);
  } else {
    ("");
  }

  if (props.modeset == "2" || props.modeset == "6") {
    locationparam = "";
    // locationparam = "?_" + (props.year1set || 2015) + "_" + (props.year2set || 2015);
    locationparam =
      "?__" +
      (props.year1set || static2map1set.year5 || 2015) +
      "_" +
      (props.year2set || static2map1set.year5 || 2015);
    // locationparam = "?_" + (props.year1set || props.static2map1set.year5 || 2015) + "_" + (props.year2set || props.static2map1set.year5 || 2015);
  } else {
    ("");
  }

  if (props.modeset == "8") {
    locationparam = "";
    // locationparam = "?_" + (props.year1set || 2015) + "_" + (props.year2set || 2015);
    locationparam =
      "?___" +
      "_" +
      (props.no2 || props.no || "11-01");
    // locationparam = "?_" + (props.year1set || props.static2map1set.year5 || 2015) + "_" + (props.year2set || props.static2map1set.year5 || 2015);
  } else {
    ("");
  }


  return (
    <>
      <Link
        to={
          linkto +
          "/" +
          props.modeset +
          "/" +
          props.no +
          "/" +
          props.area1set +
          (locationparam || "")
        }
        onClick={multisetting}
      >
        {props.children}
      </Link>
    </>
  );
};

export const Year0set = ({ xl, to }) => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  const { zoomhanrei2set, setZoomhanrei2Set } = useContext(Zoomhanrei2Set);

  // console.log(static2map1set.year5);
  // console.log(year1set);

  // 左（rfcs1）統計表示年の配列を更新 ///////////////////////////
  let year1s = [];
  useEffect(() => {
    if (static2map1set.year1) {
      year1s.push(static2map1set.year1);
    }
    if (static2map1set.year2) {
      year1s.push(static2map1set.year2);
    }
    if (static2map1set.year3) {
      year1s.push(static2map1set.year3);
    }
    if (static2map1set.year4) {
      year1s.push(static2map1set.year4);
    }
    if (static2map1set.year5) {
      year1s.push(static2map1set.year5);
    }
    if (static2map1set.year6) {
      year1s.push(static2map1set.year6);
    }
    if (static2map1set.year7) {
      year1s.push(static2map1set.year7);
    }
    if (static2map1set.year8) {
      year1s.push(static2map1set.year8);
    }
    if (static2map1set.year9) {
      year1s.push(static2map1set.year9);
    }
    if (static2map1set.year10) {
      year1s.push(static2map1set.year10);
    }
    if (static2map1set.year11) {
      year1s.push(static2map1set.year11);
    }
    if (static2map1set.year12) {
      year1s.push(static2map1set.year12);
    }
    if (static2map1set.year13) {
      year1s.push(static2map1set.year13);
    }
    if (static2map1set.year14) {
      year1s.push(static2map1set.year14);
    }
    if (static2map1set.year15) {
      year1s.push(static2map1set.year15);
    }
    // setYear1Set(year1s)
  }, [static2map1set, year1set]);
  // console.log(year1s);
  // console.log(year1set);

  const year0button = () => {
    if (year1s && year1set == 3000) {
      setYear1Set(year1s[0]);
      setYear2Set(year1s[0]);
    } else if (year1s[1] && year1set == year1s[0]) {
      setYear1Set(year1s[1]);
      setYear2Set(year1s[1]);
    } else if (year1s[2] && year1set == year1s[1]) {
      setYear1Set(year1s[2]);
      setYear2Set(year1s[2]);
    } else if (year1s[3] && year1set == year1s[2]) {
      setYear1Set(year1s[3]);
      setYear2Set(year1s[3]);
    } else if (year1s[4] && year1set == year1s[3]) {
      setYear1Set(year1s[4]);
      setYear2Set(year1s[4]);
    } else if (year1s[5] && year1set == year1s[4]) {
      setYear1Set(year1s[5]);
      setYear2Set(year1s[5]);
    } else if (year1s[6] && year1set == year1s[5]) {
      setYear1Set(year1s[6]);
      setYear2Set(year1s[6]);
    } else if (year1s[7] && year1set == year1s[6]) {
      setYear1Set(year1s[7]);
      setYear2Set(year1s[7]);
    } else if (year1s[8] && year1set == year1s[7]) {
      setYear1Set(year1s[8]);
      setYear2Set(year1s[8]);
    } else if (year1s[9] && year1set == year1s[8]) {
      setYear1Set(year1s[9]);
      setYear2Set(year1s[9]);
    } else if (year1s[10] && year1set == year1s[9]) {
      setYear1Set(year1s[10]);
      setYear2Set(year1s[10]);
    } else if (year1s[11] && year1set == year1s[10]) {
      setYear1Set(year1s[11]);
      setYear2Set(year1s[11]);
    } else if (year1s[12] && year1set == year1s[11]) {
      setYear1Set(year1s[12]);
      setYear2Set(year1s[12]);
    } else if (year1s[13] && year1set == year1s[12]) {
      setYear1Set(year1s[13]);
      setYear2Set(year1s[13]);
    } else if (year1s[14] && year1set == year1s[13]) {
      setYear1Set(year1s[14]);
      setYear2Set(year1s[14]);
    } else if (year1s[15] && year1set == year1s[14]) {
      setYear1Set(year1s[15]);
      setYear2Set(year1s[15]);
      // } else if ( !year1set ){setYear1Set(year1s[4]);setYear2Set(year1s[4]);
    } else {
      setYear1Set(3000);
      setYear2Set(3000);
    }
  };
  const location = useLocation();
  if (!to) {
    to = location.pathname;
  }
  // var to = to || location.pathname;
  // var to = to || "/map"
  const Link2m = () => {
    return (
      <>
        <Link to={to} data-tip="統計の年次を切り替えます">
          <ReactTooltip
            effect="float"
            type="info"
            place="right"
            delayShow={1000}
          />
          {xl && (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </>
          )}
          {!xl && (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 mx-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </>
          )}
        </Link>
      </>
    );
  };
  return (
    <>
      {year1set === static2map1set.year1 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year1}
        </h2>
      )}
      {year1set === static2map1set.year2 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year2}
        </h2>
      )}
      {year1set === static2map1set.year3 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year3}
        </h2>
      )}
      {year1set === static2map1set.year4 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year4}
        </h2>
      )}
      {year1set === static2map1set.year5 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year5}
        </h2>
      )}
      {year1set === static2map1set.year6 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year6}
        </h2>
      )}
      {year1set === static2map1set.year7 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year7}
        </h2>
      )}
      {year1set === static2map1set.year8 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year8}
        </h2>
      )}
      {year1set === static2map1set.year9 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year9}
        </h2>
      )}
      {year1set === static2map1set.year10 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year10}
        </h2>
      )}
      {year1set === static2map1set.year11 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year11}
        </h2>
      )}
      {year1set === static2map1set.year12 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year12}
        </h2>
      )}
      {year1set === static2map1set.year13 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year13}
        </h2>
      )}
      {year1set === static2map1set.year14 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year14}
        </h2>
      )}
      {year1set === static2map1set.year15 && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year15}
        </h2>
      )}

      {!year1set && (
        <h2 onClick={year0button}>
          <Link2m />
          {static2map1set.year5}
        </h2>
      )}
      {year1set == 3000 && (
        <h2 onClick={year0button}>
          <Link2m />
          OFF
        </h2>
      )}
    </>
  );
};


/**
 * Year0Takaku0set
 * - 左(static2map1set)と右(static2map2set)の年候補を「近い年同士」になるように全体最適でペアリング
 * - 足りない側は OFF(=3000) をギャップとして挿入
 * - クリックでペア列を巡回し、year1set/year2set を同時に切り替える
 * - 表示は「左年 / 右年」
 */
export const Year0Takaku0set = ({ xl, to }) => {
  const { static2map1set } = useContext(Static2Map1Set);
  const { static2map2set } = useContext(Static2Map2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);

  const OFF = 3000;

  // 年候補の抽出（year1..year5 のうち存在するものを昇順で）
  const leftYears = useMemo(() => {
    const s = static2map1set || {};
    return [s.year1, s.year2, s.year3, s.year4, s.year5].filter((v) => v);
  }, [static2map1set]);

  const rightYears = useMemo(() => {
    const s = static2map2set || {};
    return [s.year1, s.year2, s.year3, s.year4, s.year5].filter((v) => v);
  }, [static2map2set]);

  // DP（global alignment / Needleman–Wunsch 的）
  // match cost = |L-R|
  // gap cost   = GAP (大きめにして不要なOFF挿入を避ける。ただし長さ差がある場合は必ず必要)
  const pairs = useMemo(() => {
    const L = leftYears.map((x) => Number(x));
    const R = rightYears.map((x) => Number(x));

    // 両方空なら (OFF,OFF) だけ
    if (L.length === 0 && R.length === 0) return [{ l: OFF, r: OFF }];

    const m = L.length;
    const n = R.length;

    // 年差の典型が 0〜50 程度なら、ギャップペナルティは 500〜2000 くらいが無難
    const GAP = 1200;

    // dp[i][j] = cost (Lの先頭i個とRの先頭j個を整列)
    const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));
    const bt = Array.from({ length: m + 1 }, () => Array(n + 1).fill(null)); // "M"|"L"|"R"

    for (let i = 1; i <= m; i++) {
      dp[i][0] = dp[i - 1][0] + GAP;
      bt[i][0] = "L"; // R側ギャップ（左だけ進む）＝(L[i-1], OFF)
    }
    for (let j = 1; j <= n; j++) {
      dp[0][j] = dp[0][j - 1] + GAP;
      bt[0][j] = "R"; // L側ギャップ（右だけ進む）＝(OFF, R[j-1])
    }

    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        const costMatch = dp[i - 1][j - 1] + Math.abs(L[i - 1] - R[j - 1]);
        const costGapR = dp[i - 1][j] + GAP; // (L[i-1], OFF)
        const costGapL = dp[i][j - 1] + GAP; // (OFF, R[j-1])

        let best = costMatch;
        let move = "M";

        if (costGapR < best) {
          best = costGapR;
          move = "L";
        }
        if (costGapL < best) {
          best = costGapL;
          move = "R";
        }

        dp[i][j] = best;
        bt[i][j] = move;
      }
    }

    // 復元
    const out = [];
    let i = m,
      j = n;
    while (i > 0 || j > 0) {
      const move = bt[i][j];
      if (move === "M") {
        out.push({ l: L[i - 1], r: R[j - 1] });
        i--;
        j--;
      } else if (move === "L") {
        out.push({ l: L[i - 1], r: OFF });
        i--;
      } else {
        // "R"
        out.push({ l: OFF, r: R[j - 1] });
        j--;
      }
    }
    out.reverse();

    // 念のため空になったらOFF
    return out.length ? out : [{ l: OFF, r: OFF }];
  }, [leftYears, rightYears]);

    // ★「両方OFF」の回を必ず追加（1ステップ増やす）
  const pairs2 = useMemo(() => {
    return [...pairs, { l: OFF, r: OFF }];
  }, [pairs]);

  // いまの year1set/year2set に対応するペア位置（なければ末尾）
  const currentIndex = useMemo(() => {
    const y1 = Number(year1set ?? OFF);
    const y2 = Number(year2set ?? OFF);
    const idx = pairs2.findIndex((p) => p.l === y1 && p.r === y2);
    return idx >= 0 ? idx : Math.max(0, pairs.length - 1);
  }, [pairs2, year1set, year2set]);

  const [idx, setIdx] = useState(currentIndex);

  // pairsが変わったら idx を追従
  useEffect(() => {
    setIdx(currentIndex);
  }, [currentIndex]);

  // 初期表示：末尾（＝最終側に寄りやすい）に揃える
  // 「初回だけ」適用したいので ref でガード
  const didInit = useRef(false);
  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;

    const last = pairs[pairs.length - 1];
    // yearが未設定っぽい場合のみ初期化（既に状態がある場合は尊重）
    const y1 = year1set;
    const y2 = year2set;
    const y1Unset = y1 === undefined || y1 === null || y1 === "";
    const y2Unset = y2 === undefined || y2 === null || y2 === "";

    if (y1Unset && y2Unset) {
      setYear1Set(last.l);
      setYear2Set(last.r);
      setIdx(pairs.length - 1);
    }
  }, [pairs, setYear1Set, setYear2Set, year1set, year2set]);

  const onClick = () => {
    const next = (idx + 1) % pairs2.length;
    const p = pairs2[next];
    setIdx(next);
    setYear1Set(p.l);
    setYear2Set(p.r);
  };

  const location = useLocation();
  if (!to) to = location.pathname;

  const fmt = (y) => (Number(y) === OFF ? "OFF" : String(y));

  const display = `${fmt(pairs2[idx]?.r ?? OFF)} / ${fmt(pairs2[idx]?.l ?? OFF)}`;

  const IconLink = () => (
    <Link to={to} data-tip="統計の年次（左右）を近い年同士で同時に切り替えます">
      <ReactTooltip effect="float" type="info" place="right" delayShow={1000} />
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={(xl ? "h-6 w-6" : "h-6 w-6") + " mx-auto"}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </Link>
  );

  return (
    <h2 onClick={onClick}>
      <IconLink />
      {display}
    </h2>
  );
};








export const Year1set = ({ xl, to }) => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  const { zoomhanrei2set, setZoomhanrei2Set } = useContext(Zoomhanrei2Set);

  // console.log(static2map1set.year5);
  // console.log(year1set);

  // 左（rfcs1）統計表示年の配列を更新 ///////////////////////////
  let year1s = [];
  useEffect(() => {
    if (static2map1set.year1) {
      year1s.push(static2map1set.year1);
    }
    if (static2map1set.year2) {
      year1s.push(static2map1set.year2);
    }
    if (static2map1set.year3) {
      year1s.push(static2map1set.year3);
    }
    if (static2map1set.year4) {
      year1s.push(static2map1set.year4);
    }
    if (static2map1set.year5) {
      year1s.push(static2map1set.year5);
    }
    if (static2map1set.year6) {
      year1s.push(static2map1set.year6);
    }
    if (static2map1set.year7) {
      year1s.push(static2map1set.year7);
    }
    if (static2map1set.year8) {
      year1s.push(static2map1set.year8);
    }
    if (static2map1set.year9) {
      year1s.push(static2map1set.year9);
    }
    if (static2map1set.year10) {
      year1s.push(static2map1set.year10);
    }
    if (static2map1set.year11) {
      year1s.push(static2map1set.year11);
    }
    if (static2map1set.year12) {
      year1s.push(static2map1set.year12);
    }
    if (static2map1set.year13) {
      year1s.push(static2map1set.year13);
    }
    if (static2map1set.year14) {
      year1s.push(static2map1set.year14);
    }
    if (static2map1set.year15) {
      year1s.push(static2map1set.year15);
    }
    // setYear1Set(year1s)
  }, [static2map1set, year1set]);
  // console.log(year1s);
  // console.log(year1set);

  const year1button = () => {
    var yeartmp;
    if (year1s && year1set == 3000) {
      setYear1Set(year1s[0]);
      yeartmp = year1s[0];
    } else if (year1s[1] && year1set == year1s[0]) {
      setYear1Set(year1s[1]);
      yeartmp = year1s[1];
    } else if (year1s[2] && year1set == year1s[1]) {
      setYear1Set(year1s[2]);
      yeartmp = year1s[2];
    } else if (year1s[3] && year1set == year1s[2]) {
      setYear1Set(year1s[3]);
      yeartmp = year1s[3];
    } else if (year1s[4] && year1set == year1s[3]) {
      setYear1Set(year1s[4]);
      yeartmp = year1s[4];
    } else if (year1s[5] && year1set == year1s[4]) {
      setYear1Set(year1s[5]);
      yeartmp = year1s[5];
    } else if (year1s[6] && year1set == year1s[5]) {
      setYear1Set(year1s[6]);
      yeartmp = year1s[6];
    } else if (year1s[7] && year1set == year1s[6]) {
      setYear1Set(year1s[7]);
      yeartmp = year1s[7];
    } else if (year1s[8] && year1set == year1s[7]) {
      setYear1Set(year1s[8]);
      yeartmp = year1s[8];
    } else if (year1s[9] && year1set == year1s[8]) {
      setYear1Set(year1s[9]);
      yeartmp = year1s[9];
    } else if (year1s[10] && year1set == year1s[9]) {
      setYear1Set(year1s[10]);
      yeartmp = year1s[10];
    } else if (year1s[11] && year1set == year1s[10]) {
      setYear1Set(year1s[11]);
      yeartmp = year1s[11];
    } else if (year1s[12] && year1set == year1s[11]) {
      setYear1Set(year1s[12]);
      yeartmp = year1s[12];
    } else if (year1s[13] && year1set == year1s[12]) {
      setYear1Set(year1s[13]);
      yeartmp = year1s[13];
    } else if (year1s[14] && year1set == year1s[13]) {
      setYear1Set(year1s[14]);
      yeartmp = year1s[14];
    } else if (year1s[15] && year1set == year1s[14]) {
      setYear1Set(year1s[15]);
      yeartmp = year1s[15];
      // } else if ( !year1set ){setYear1Set(year1s[4]);setYear2Set(year1s[4]);
    } else {
      setYear1Set(3000);
      yeartmp = 3000;
    }
    history.pushState(
      "",
      "",
      location.pathname + "?__" + (yeartmp || year1set) + "_" + year2set
    );

    // 一番古い年次とOFFだけにする場合（動作します 20220306）
    // if (year1s && year1set == 3000) {
    //   setYear1Set(year1s[0]);
    // } else {
    //   setYear1Set(3000);
    // }
  };
  const location = useLocation();
  if (!to) {
    to = location.pathname;
  }
  // var to = to || location.pathname;
  // var to = to || "/map"
  const Link2m = () => {
    return (
      <>
        <Link to={to} data-tip="統計の年次を切り替えます">
          <ReactTooltip
            effect="float"
            type="info"
            place="right"
            delayShow={1000}
          />
          {xl && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mx-auto"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          )}
          {!xl && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mx-auto"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          )}
        </Link>
      </>
    );
  };
  return (
    <>
      <h2 onClick={year1button}>
        <Link2m />
        {year1set == static2map1set.year1 && <>{static2map1set.year1}</>}
        {year1set == static2map1set.year2 && <>{static2map1set.year2}</>}
        {year1set == static2map1set.year3 && <>{static2map1set.year3}</>}
        {year1set == static2map1set.year4 && <>{static2map1set.year4}</>}
        {year1set == static2map1set.year5 && <>{static2map1set.year5}</>}
        {year1set == static2map1set.year6 && <>{static2map1set.year6}</>}
        {year1set == static2map1set.year7 && <>{static2map1set.year7}</>}
        {year1set == static2map1set.year8 && <>{static2map1set.year8}</>}
        {year1set == static2map1set.year9 && <>{static2map1set.year9}</>}
        {year1set == static2map1set.year10 && <>{static2map1set.year10}</>}
        {year1set == static2map1set.year11 && <>{static2map1set.year11}</>}
        {year1set == static2map1set.year12 && <>{static2map1set.year12}</>}
        {year1set == static2map1set.year13 && <>{static2map1set.year13}</>}
        {year1set == static2map1set.year14 && <>{static2map1set.year14}</>}
        {year1set == static2map1set.year15 && <>{static2map1set.year15}</>}
        {!year1set && <>{static2map1set.year5}</>}
        {year1set == 3000 && <>OFF</>}
      </h2>
    </>
  );
};

export const Year2set = ({ xl, to }) => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  const { zoomhanrei2set, setZoomhanrei2Set } = useContext(Zoomhanrei2Set);

  const [urlset, setUrlset] = useState("?");

  // const locationurl = useLocation();
  // console.log(locationurl);
  // const locationurlsetting = decodeURI(locationurl.search).split("_")
  // const params = useParams();
  // console.log(params);
  // console.log(static2map1set.year5);
  // console.log(year1set);
  // if(locationurlsetting[2]){
  //   setYear1Set(Number(locationurlsetting[2]))
  // }
  // if(locationurlsetting[3]){
  //   setYear2Set(Number(locationurlsetting[3]))
  // }

  // var locationurlparam="";

  // 右（rfcs1）統計表示年の配列を更新 ///////////////////////////
  let year1s = [];
  useEffect(() => {
    if (static2map2set.year1) {
      year1s.push(static2map2set.year1);
    }
    if (static2map2set.year2) {
      year1s.push(static2map2set.year2);
    }
    if (static2map2set.year3) {
      year1s.push(static2map2set.year3);
    }
    if (static2map2set.year4) {
      year1s.push(static2map2set.year4);
    }
    if (static2map2set.year5) {
      year1s.push(static2map2set.year5);
    }
    // setYear1Set(year1s)
  }, [static2map2set, year2set]);
  // console.log(year1s);
  // console.log(year1set);

  const year2button = () => {
    var yeartmp;
    if (year1s && year2set == 3000) {
      setYear2Set(year1s[0]);
      yeartmp = year1s[0];
    } else if (year1s[1] && year2set == year1s[0]) {
      setYear2Set(year1s[1]);
      yeartmp = year1s[1];
    } else if (year1s[2] && year2set == year1s[1]) {
      setYear2Set(year1s[2]);
      yeartmp = year1s[2];
    } else if (year1s[3] && year2set == year1s[2]) {
      setYear2Set(year1s[3]);
      yeartmp = year1s[3];
    } else if (year1s[4] && year2set == year1s[3]) {
      setYear2Set(year1s[4]);
      yeartmp = year1s[4];
      // } else if ( !year1set ){setYear1Set(year1s[4]);setYear2Set(year1s[4]);
    } else {
      setYear2Set(3000);
      yeartmp = 3000;
    }

    history.pushState(
      "",
      "",
      location.pathname + "?__" + year1set + "_" + (yeartmp || year2set)
    );
    // if (year1s && year2set == 3000) {
    //   setYear2Set(year1s.slice(-1)[0]);
    // } else {
    //   setYear2Set(3000);
    // }
  };

  // var linkto;
  //   if(params.mode == "2"){
  //     console.log(locationurl.pathname);
  //     if(year1s){
  //       console.log(year1s);
  //     }
  //     if(params.mode == 2){
  //       // console.log(props.modeset);
  //       locationurlparam = "";
  //       // locationurlparam = "?_" + (props.year1set || 2015) + "_" + (props.year2set || 2015);
  //       locationurlparam = "?__" + (year1set || static2map1set.year5 || 2015) + "_" + (year2set || static2map1set.year5 || 2015);
  //       // locationurlparam = "?_" + (props.year1set || props.static2map1set.year5 || 2015) + "_" + (props.year2set || props.static2map1set.year5 || 2015);
  //     }

  //     linkto = locationurl.pathname + urlset || "/map";
  //   } else {
  //     linkto = locationurl.pathname || "/map";
  //   }
  if (!to) {
    to = location.pathname;
  }
  // var to = to || locationurl.pathname;
  // var to = to || "/map"

  const Link2m = () => {
    return (
      <>
        <div
          // to={
          //   location.pathname + ( locationurlparam || "" )
          // }
          data-tip="統計の年次を切り替えます"
        >
          <ReactTooltip
            effect="float"
            type="info"
            place="right"
            delayShow={1000}
          />
          {xl && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mx-auto"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            // <svg
            //   className="w-12 h-12 mx-auto"
            //   fill="none"
            //   stroke="currentColor"
            //   viewBox="0 0 24 24"
            //   xmlns="http://www.w3.org/2000/svg"
            // >
            //   <path
            //     strokeLinecap="round"
            //     strokeLinejoin="round"
            //     strokeWidth="2"
            //     d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            //   ></path>
            // </svg>
          )}
          {!xl && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mx-auto"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            // <svg
            //   className="w-6 h-6 mx-auto"
            //   fill="none"
            //   stroke="currentColor"
            //   viewBox="0 0 24 24"
            //   xmlns="http://www.w3.org/2000/svg"
            // >
            //   <path
            //     strokeLinecap="round"
            //     strokeLinejoin="round"
            //     strokeWidth="2"
            //     d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            //   ></path>
            // </svg>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      <h2 onClick={year2button}>
        <Link2m />
        {year2set == static2map2set.year1 && <>{static2map2set.year1}</>}
        {year2set == static2map2set.year2 && <>{static2map2set.year2}</>}
        {year2set == static2map2set.year3 && <>{static2map2set.year3}</>}
        {year2set == static2map2set.year4 && <>{static2map2set.year4}</>}
        {year2set == static2map2set.year5 && <>{static2map2set.year5}</>}
        {!year2set && <>{static2map2set.year5}</>}
        {year2set == 3000 && <>OFF</>}
      </h2>
    </>
  );
};

export const Static2Map0aset = ({ xl, to }) => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const map0button = () => {
    if (static2map1set === population_now) {
      setStatic2Map1Set(population_old);
      setStatic2Map2Set(population_now);
    } else if (static2map1set === population_old) {
      setStatic2Map1Set(agedpop_now);
      setStatic2Map2Set(agedpop_now);
    } else if (static2map1set === agedpop_now) {
      setStatic2Map1Set(agedpop_old);
      setStatic2Map2Set(agedpop_old);
    } else if (static2map1set === agedpop_old) {
      setStatic2Map1Set(worker23_now);
      setStatic2Map2Set(worker23_now);
    } else if (static2map1set === worker23_now) {
      setStatic2Map1Set(worker23_old);
      setStatic2Map2Set(worker23_old);
    } else if (static2map1set === worker23_old) {
      setStatic2Map1Set(daypop_now);
      setStatic2Map2Set(daypop_now);
    } else if (static2map1set === daypop_now) {
      setStatic2Map1Set(daypop_old);
      setStatic2Map2Set(daypop_old);
    } else if (static2map1set === daypop_old) {
      setStatic2Map1Set(sales_now);
      setStatic2Map2Set(sales_now);
    } else if (static2map1set === sales_now) {
      setStatic2Map1Set(sales_old);
      setStatic2Map2Set(sales_old);
    } else if (static2map1set === sales_old) {
      setStatic2Map1Set(null);
      setStatic2Map2Set(null);
    } else if (static2map1set === null) {
      setStatic2Map1Set(population_now);
      setStatic2Map2Set(population_now);
    } else {
      setStatic2Map1Set(population_now);
      setStatic2Map2Set(population_now);
    }
  };
  if (!to) {
    to = "/map";
  }
  // var to = to || "/map";
  const Link2m = () => {
    return (
      <Link to={to} data-tip="統計の種類を切り替えます">
        <ReactTooltip
          effect="float"
          type="info"
          place="right"
          delayShow={1000}
        />
        {xl && (
          <svg
            className="w-12 h-12 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        )}
        {!xl && (
          <svg
            className="w-6 h-6 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        )}
      </Link>
    );
  };
  return (
    <>
      {static2map1set === population_now && (
        <h2 onClick={map0button}>
          <Link2m />
          人口
          <br />
          （今）
          <br />
        </h2>
      )}
      {static2map1set === population_old && (
        <h2 onClick={map0button}>
          <Link2m />
          人口
          <br />
          （昔）
          <br />
        </h2>
      )}
      {static2map1set === agedpop_now && (
        <h2 onClick={map0button}>
          <Link2m />
          高齢
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map1set === agedpop_old && (
        <h2 onClick={map0button}>
          <Link2m />
          高齢
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === worker23_now && (
        <h2 onClick={map0button}>
          <Link2m />
          就業
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map1set === worker23_old && (
        <h2 onClick={map0button}>
          <Link2m />
          就業
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === daypop_now && (
        <h2 onClick={map0button}>
          <Link2m />
          昼間
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map1set === daypop_old && (
        <h2 onClick={map0button}>
          <Link2m />
          昼間
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === sales_now && (
        <h2 onClick={map0button}>
          <Link2m />
          販売
          <br />
          金額
          <br />
          （今）
        </h2>
      )}
      {static2map1set === sales_old && (
        <h2 onClick={map0button}>
          <Link2m />
          販売
          <br />
          金額
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === null && (
        <h2 onClick={map0button}>
          <Link2m />
          地図
          <br />
          表示
        </h2>
      )}
    </>
  );
};

export const Static2Map0set = ({ xl, to }) => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const map0button = () => {
    if (
      static2map1set === population_now ||
      static2map1set === population_old
    ) {
      setStatic2Map1Set(agedpop_old);
      setStatic2Map2Set(agedpop_now);
    } else if (
      static2map1set === agedpop_now ||
      static2map1set === agedpop_old
    ) {
      setStatic2Map1Set(worker23_old);
      setStatic2Map2Set(worker23_now);
    } else if (
      static2map1set === worker23_now ||
      static2map1set === worker23_old
    ) {
      setStatic2Map1Set(daypop_old);
      setStatic2Map2Set(daypop_now);
    } else if (static2map1set === daypop_now || static2map1set === daypop_old) {
      setStatic2Map1Set(sales_old);
      setStatic2Map2Set(sales_now);
    } else if (static2map1set === sales_now || static2map1set === sales_old) {
      setStatic2Map1Set(null);
      setStatic2Map2Set(null);
    } else if (static2map1set === null) {
      setStatic2Map1Set(population_old);
      setStatic2Map2Set(population_now);
    } else {
      setStatic2Map1Set(population_old);
      setStatic2Map2Set(population_now);
    }
  };
  if (!to) {
    to = "/map";
  }
  // var to = to || "/map";
  const Link2m = ({ xl, to }) => {
    return (
      <Link to={to} data-tip="統計の種類を切り替えます">
        <ReactTooltip
          effect="float"
          type="info"
          place="right"
          delayShow={1000}
        />
        {xl && (
          <svg
            className="w-12 h-12 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        )}
        {!xl && (
          <svg
            className="w-6 h-6 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
        )}
      </Link>
    );
  };
  return (
    <>
      {static2map1set === population_now && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          人口
          <br />
        </h2>
      )}
      {static2map1set === population_old && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          人口
          <br />
        </h2>
      )}
      {static2map1set === agedpop_now && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          高齢
          <br />
          人口
        </h2>
      )}
      {static2map1set === agedpop_old && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          高齢
          <br />
          人口
        </h2>
      )}
      {static2map1set === worker23_now && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          就業
          <br />
          人口
        </h2>
      )}
      {static2map1set === worker23_old && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          就業
          <br />
          人口
        </h2>
      )}
      {static2map1set === daypop_now && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          昼間
          <br />
          人口
        </h2>
      )}
      {static2map1set === daypop_old && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          昼間
          <br />
          人口
        </h2>
      )}
      {static2map1set === sales_now && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          販売
          <br />
          金額
        </h2>
      )}
      {static2map1set === sales_old && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          販売
          <br />
          金額
        </h2>
      )}
      {static2map1set === null && (
        <h2 onClick={map0button}>
          <Link2m xl={xl} to={to} />
          地図
          <br />
          表示
        </h2>
      )}
    </>
  );
};

export const Static2Map1set = (props) => {
  const { map1set, setMap1Set } = useContext(Map1Set);
  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const map1button = () => {
    if (static2map1set === population_now) {
      setStatic2Map1Set(population_old);
    } else if (static2map1set === population_old) {
      setStatic2Map1Set(agedpop_now);
    } else if (static2map1set === agedpop_now) {
      setStatic2Map1Set(agedpop_old);
    } else if (static2map1set === agedpop_old) {
      setStatic2Map1Set(worker23_now);
    } else if (static2map1set === worker23_now) {
      setStatic2Map1Set(worker23_old);
    } else if (static2map1set === worker23_old) {
      setStatic2Map1Set(daypop_now);
    } else if (static2map1set === daypop_now) {
      setStatic2Map1Set(daypop_old);
    } else if (static2map1set === daypop_old) {
      setStatic2Map1Set(sales_now);
    } else if (static2map1set === sales_now) {
      setStatic2Map1Set(sales_old);
    } else if (static2map1set === sales_old) {
      setStatic2Map1Set(null);
    } else if (static2map1set === null) {
      setStatic2Map1Set(population_now);
    } else {
      setStatic2Map1Set(population_now);
    }
  };
  const Link2m = () => {
    return (
      <Link to="/map" data-tip="統計の種類を切り替えます">
        <ReactTooltip
          effect="float"
          type="info"
          place="right"
          delayShow={1000}
        />{" "}
        <svg
          className="w-6 h-6 mx-auto"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          ></path>
        </svg>
      </Link>
    );
  };
  return (
    <>
      {static2map1set === population_now && (
        <h2 onClick={map1button}>
          <Link2m />
          人口
          <br />
          （今）
          <br />
        </h2>
      )}
      {static2map1set === population_old && (
        <h2 onClick={map1button}>
          <Link2m />
          人口
          <br />
          （昔）
          <br />
        </h2>
      )}
      {static2map1set === agedpop_now && (
        <h2 onClick={map1button}>
          <Link2m />
          高齢
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map1set === agedpop_old && (
        <h2 onClick={map1button}>
          <Link2m />
          高齢
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === worker23_now && (
        <h2 onClick={map1button}>
          <Link2m />
          就業
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map1set === worker23_old && (
        <h2 onClick={map1button}>
          <Link2m />
          就業
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === daypop_now && (
        <h2 onClick={map1button}>
          <Link2m />
          昼間
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map1set === daypop_old && (
        <h2 onClick={map1button}>
          <Link2m />
          昼間
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === sales_now && (
        <h2 onClick={map1button}>
          <Link2m />
          販売
          <br />
          金額
          <br />
          （今）
        </h2>
      )}
      {static2map1set === sales_old && (
        <h2 onClick={map1button}>
          <Link2m />
          販売
          <br />
          金額
          <br />
          （昔）
        </h2>
      )}
      {static2map1set === null && (
        <h2 onClick={map1button}>
          <Link2m />
          地図
          <br />
          表示
          <br />
        </h2>
      )}
    </>
  );
};

export const Static2Map2set = (props) => {
  const { map2set, setMap2Set } = useContext(Map2Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);
  const map2button = () => {
    if (static2map2set === population_now) {
      setStatic2Map2Set(population_old);
    } else if (static2map2set === population_old) {
      setStatic2Map2Set(agedpop_now);
    } else if (static2map2set === agedpop_now) {
      setStatic2Map2Set(agedpop_old);
    } else if (static2map2set === agedpop_old) {
      setStatic2Map2Set(worker23_now);
    } else if (static2map2set === worker23_now) {
      setStatic2Map2Set(worker23_old);
    } else if (static2map2set === worker23_old) {
      setStatic2Map2Set(daypop_now);
    } else if (static2map2set === daypop_now) {
      setStatic2Map2Set(daypop_old);
    } else if (static2map2set === daypop_old) {
      setStatic2Map2Set(sales_now);
    } else if (static2map2set === sales_now) {
      setStatic2Map2Set(sales_old);
    } else if (static2map2set === sales_old) {
      setStatic2Map2Set(null);
    } else if (static2map2set === null) {
      setStatic2Map2Set(population_now);
    } else {
      setStatic2Map2Set(population_now);
    }
  };
  const Link2m = () => {
    return (
      <Link to="/map" data-tip="統計の種類を切り替えます">
        <ReactTooltip
          effect="float"
          type="info"
          place="right"
          delayShow={1000}
        />{" "}
        <svg
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          className="mx-auto w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </Link>
    );
  };

  return (
    <>
      {static2map2set === population_now && (
        <h2 onClick={map2button}>
          <Link2m />
          人口
          <br />
          （今）
          <br />
        </h2>
      )}
      {static2map2set === population_old && (
        <h2 onClick={map2button}>
          <Link2m />
          人口
          <br />
          （昔）
          <br />
        </h2>
      )}
      {static2map2set === agedpop_now && (
        <h2 onClick={map2button}>
          <Link2m />
          高齢
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map2set === agedpop_old && (
        <h2 onClick={map2button}>
          <Link2m />
          高齢
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map2set === worker23_now && (
        <h2 onClick={map2button}>
          <Link2m />
          就業
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map2set === worker23_old && (
        <h2 onClick={map2button}>
          <Link2m />
          就業
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map2set === daypop_now && (
        <h2 onClick={map2button}>
          <Link2m />
          昼間
          <br />
          人口
          <br />
          （今）
        </h2>
      )}
      {static2map2set === daypop_old && (
        <h2 onClick={map2button}>
          <Link2m />
          昼間
          <br />
          人口
          <br />
          （昔）
        </h2>
      )}
      {static2map2set === sales_now && (
        <h2 onClick={map2button}>
          <Link2m />
          販売
          <br />
          金額
          <br />
          （今）
        </h2>
      )}
      {static2map2set === sales_old && (
        <h2 onClick={map2button}>
          <Link2m />
          販売
          <br />
          金額
          <br />
          （昔）
        </h2>
      )}
      {static2map2set === null && (
        <h2 onClick={map2button}>
          <Link2m />
          地図
          <br />
          表示
          <br />
        </h2>
      )}
    </>
  );
};
